module.exports = __webpack_public_path__ + "img/TCC-L8-Pagina2 A.1ab0a251.png";